export enum SanjeevaniEnum {
  Deposit,
  Winthdraw,
  ExportToExcelClick,
  FilterClick,
  SearchClick,
  // ExportToExcelClickWithdraw,
}
